import { Select, SelectItem } from '@tremor/react';
import type { Store } from '../api/types';
import { t } from '../lib/i18n';

interface Props {
  stores: Store[];
  value: number | null; // null = all
  onChange: (sid: number | null) => void;
  disabled?: boolean;
}

const ALL = '__all__';

export default function StoreFilter({ stores, value, onChange, disabled }: Props) {
  return (
    <Select
      value={value === null ? ALL : String(value)}
      onValueChange={(v) => onChange(v === ALL ? null : Number(v))}
      disabled={disabled}
      className="w-56"
      aria-label={t.filter.store}
    >
      <SelectItem value={ALL}>{t.filter.allStores}</SelectItem>
      {stores.map((s) => (
        <SelectItem key={s.sid} value={String(s.sid)}>{s.name}</SelectItem>
      ))}
    </Select>
  );
}
